import Model from "./base/model";

class Supplier extends Model {
  resourceName() {
    return 'suppliers';
  }

  fields() {
    return {
      social_reason: "",
      cnpj: "",
      fantasy_name:"",
      municipal_registration: "",
      state_registration: "",
      telephone: "",
      type: "",
      address_id: "",
      responsible: { jsonApi: "hasOne", type: "users"},
      address: { jsonApi: "hasOne", type: "adresses" },
      features: { jsonApi: "hasMany", type: "company_features" },
      two_factor_authentication: "",
      receive_notification: "",
    };
  }

  async search(data) {
    return this.request(
      this.resourceName() + "/search",
      "POST",
      {include:"address"},
      data
    );
  }
}

export default new Supplier();
